import { render, staticRenderFns } from "./price-selector.vue?vue&type=template&id=3f4a50d1&scoped=true&"
import script from "./price-selector.vue?vue&type=script&lang=js&"
export * from "./price-selector.vue?vue&type=script&lang=js&"
import style0 from "./price-selector.vue?vue&type=style&index=0&id=3f4a50d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4a50d1",
  null
  
)

export default component.exports